export default "__VITE_ASSET__Do9FFD6z__"